import { Box, Typography } from '@mui/material';
import React from 'react';
import TwCheckbox from '../../../components/TwCheckboxes/TwCheckboxes';
import FactoringUtils from '../../../utils/factoringUtils';
import TwTooltip from '../../../components/TwTooltip/TwTooltip';

export interface FactorInvoiceProps {
  factorInvoice: boolean;
  factoringCompany: string;
  isMultiLoadInvoice: boolean;
  handleFactorInvoiceChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FactorInvoice: React.FC<FactorInvoiceProps> = ({
  factorInvoice,
  factoringCompany,
  isMultiLoadInvoice,
  handleFactorInvoiceChange
}): JSX.Element => {
  return (
    <TwTooltip
      title={isMultiLoadInvoice ? 'Bulk invoices cannot be sent via factoring' : ''}
      placement="top-start"
    >
      <Box className="create-invoice__factor-invoice">
        <TwCheckbox
          name="factorInvoice"
          label="Factor Invoice"
          checked={factorInvoice && !isMultiLoadInvoice}
          onInputChange={handleFactorInvoiceChange}
          disabled={isMultiLoadInvoice}
        />
        <Typography
          className="create-invoice__factor-invoice__send-to"
          variant="inherit"
          color="#6b7280"
        >
          Send to {FactoringUtils.capitalizeFirstLetterCompany(factoringCompany)}
        </Typography>
      </Box>
    </TwTooltip>
  );
};

export default FactorInvoice;
